var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.211 15.414c1.419-1.419 3.652-1.55 5.137-.3l1.073.903c1.225 1.03 1.35 2.889.276 4.149a3.476 3.476 0 0 1-2.3 1.187c-3.428.462-7.025-1.19-10.792-4.958-3.768-3.768-5.42-7.366-4.96-10.794.025-.268.08-.533.167-.788.2-.586.552-1.108 1.021-1.512 1.261-1.072 3.118-.949 4.148.277l.903 1.073c1.25 1.484 1.12 3.718-.298 5.137l-.77.769a.746.746 0 0 0-.172.785c.28.765.995 1.722 2.143 2.87 1.149 1.15 2.106 1.863 2.87 2.145.274.1.58.032.785-.174l.77-.769Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone28);
export default __webpack_public_path__ + "static/media/phone_28.1c6eb042.svg";
export { ForwardRef as ReactComponent };